import { Table } from "react-bootstrap";
import { useFDSContext } from "../contexts/FDSContext";

const FDSs = () => {
    const {fdss} = useFDSContext();

    return <Table striped bordered hover responsive size="sm">
            <thead>
                <tr>
                    <th>PRODUCTO</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {
                    fdss.map((fds, i) => {
                        return <tr key={`${i}`} className="fila">
                                    <td>{fds.descripcion}</td>
                                    <td><a href={`${process.env.PUBLIC_URL}/fds/${fds.archivo}`} className="btn btn-primary btn-sm btn-download" rel="noreferrer" target="_blank" download>DESCARGAR DOCUMENTO</a></td>
                                </tr>
                    })
                }
            </tbody>
        </Table>
}

export default FDSs;